// generateMenuPdf.js
import jsPDF from "jspdf";
import "jspdf-autotable";
import { instance2 } from "../utils/axiosInstance";
import { localDateString } from "src/lib/utils";
import BgnIcon from "../img/logobgn250.png";


export async function downloadMenuPDF(startDate, endDate, kitchenData) {
  // Coerce to YYYY-MM-DD using your util (handles Date or string inputs)
  const startStr = localDateString(new Date(startDate));
  const endStr   = localDateString(new Date(endDate));

  const kitchenId = localStorage.getItem("kitchenId") || "";
  const url = `/menu_schedule/kitchen/${kitchenId}/${startStr}/${endStr}`;

  const res = await instance2.get(url);

  // Axios: status is numeric; throw if not 2xx
  if (res.status !== "OK") {
    throw new Error(`Gagal mengambil data menu (${res.status})`);
  }

  // Many APIs return either an array or { data: [...] }
  const payload = res.data;
  const data = Array.isArray(payload) ? payload : (payload?.data ?? []);

  // ---- Prepare rows ----
  const toDash = (v) => (v === null || v === undefined ? "-" : String(v));
  const fmtDate = (iso) => {
    try {
      const d = new Date(iso);
      return isNaN(d)
        ? "-"
        : d.toLocaleDateString("id-ID", {
            year: "numeric",
            month: "long",
            day: "2-digit",
          });
    } catch {
      return "-";
    }
  };

  const body = (Array.isArray(data) ? data : []).map((row, i) => [
    String(i + 1),                                // No.
    fmtDate(row.date),                            // Tanggal
    toDash(row.KARBOHIDRAT),
    toDash(row.PROTEIN),
    toDash(row.SAYURAN),
    toDash(row.BUAH),
    toDash(row.MINUMAN),
  ]);

// ---- Build PDF (landscape) ----
const leftMargin = 80;   // wider left
const rightMargin = 50;  // narrower right
const topMargin = 60;
const bottomMargin = 40;

const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });

// Load icon to base64
const loadImageAsBase64 = (imgSrc) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "Anonymous";
    img.src = imgSrc;
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = (err) => reject(err);
  });

const iconBase64 = await loadImageAsBase64(BgnIcon);

// Title strings
const titleStart = new Date(startStr).toLocaleDateString("id-ID", {
  year: "numeric", month: "long", day: "2-digit",
});
const titleEnd = new Date(endStr).toLocaleDateString("id-ID", {
  year: "numeric", month: "long", day: "2-digit",
});

// --- Place ICON directly ABOVE the "Menu ..." title ---
const iconWidth = 66;
const iconHeight = 66;

const titleX = leftMargin;
const titleY = topMargin;

// icon shares the same X as the title, sits just above it
const iconX = titleX;
const iconY = titleY - iconHeight + 25; // 6pt gap above the title line
// Draw icon
doc.addImage(iconBase64, "PNG", iconX, iconY, iconWidth, iconHeight);

// Compute a safe text area (to the right of the icon)
const pageWidth  = doc.internal.pageSize.getWidth();
const gapAfterIcon = 10; // horizontal gap after icon
const safeLeft   = Math.max(leftMargin, iconX + iconWidth + gapAfterIcon);
const safeRight  = pageWidth - rightMargin;
const centerX    = (safeLeft + safeRight) / 2;
const maxWidth   = safeRight - safeLeft;

// Headline
doc.setFontSize(16);
doc.setFont("helvetica", "bold");
doc.setTextColor(59, 78, 135);
doc.text("LAPORAN PRODUKSI MINGGUAN", centerX, titleY - 20, { align: "center" });

// Kitchen name
const kitchenName = (kitchenData?.[0]?.kitchen_name) || "";
doc.setFontSize(8);
doc.text(kitchenName, centerX, titleY - 5, { align: "center" });

// Kitchen address (wrap to stay within safe area)
const kitchenAddr = (kitchenData?.[0]?.kitchen_address) || "";
const addrLines = doc.splitTextToSize(kitchenAddr, maxWidth);
doc.text(addrLines, centerX, titleY + 5, { align: "center" });

// Reset color
doc.setTextColor(0, 0, 0);

// Main title
doc.setFontSize(14);
doc.setTextColor(0, 0, 0);
doc.text(`Menu ${titleStart} s/d ${titleEnd}`, titleX, titleY + 50);

// Table
doc.autoTable({
  startY: topMargin + 70, // start below the header
  head: [[
    "No", "Tanggal", "Karbohidrat", "Protein", "Sayuran", "Buah", "Minuman",
  ]],
  body ,
  theme: "grid",
  styles: {
    fontSize: 10,
    lineWidth: 0.2,
    lineColor: [0, 0, 0],
    halign: "left",
    valign: "middle",
    textColor: [0, 0, 0],
  },
  headStyles: {
    fillColor: [255, 255, 255],
    textColor: [0, 0, 0],
    fontStyle: "bold",
    halign: "center",
  },
  columnStyles: {
    0: { cellWidth: 30, halign: "center" }, // No
    1: { cellWidth: 120 },                  // Tanggal
  },
  margin: { top: topMargin + 20, left: leftMargin, right: rightMargin, bottom: bottomMargin },
  didDrawPage: () => {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
      const pageCount = doc.internal.getNumberOfPages();
    doc.setFontSize(9);
    doc.text(
      `Hal. ${doc.internal.getCurrentPageInfo().pageNumber} / ${pageCount}`,
      pageWidth - rightMargin, // respect right margin
      pageHeight - 10,
      { align: "right" }
    );
  },
});

  doc.save(`Menu_${startStr}_sd_${endStr}.pdf`);
}
